import React from 'react';

type AgentBannerProps = {
  agentMessage: string;
  agentMessageType: 'outline' | 'content';
  setAgentMessage: React.Dispatch<React.SetStateAction<string | null>>;
};

export function AgentBanner({ agentMessage, agentMessageType, setAgentMessage }: AgentBannerProps) {
  return (
    <div
      className={`cp-agent-banner cp-agent-banner--${agentMessageType}`}
      role="status"
      aria-live="polite"
    >
      <span className="cp-agent-banner__icon">
        {agentMessageType === 'content' ? '✨' : '🤖'}
      </span>
      <div className="cp-agent-banner__body">
        <div className="cp-agent-banner__label">
          {agentMessageType === 'content' ? 'Content Agent' : 'Outline Agent'}
        </div>
        <div className="cp-agent-banner__message">{agentMessage}</div>
      </div>
      <button
        className="cp-agent-banner__dismiss"
        onClick={() => setAgentMessage(null)}
        aria-label="Dismiss message"
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
